module.exports = __webpack_public_path__ + "media/images/svg/icon_arrow_left-a6dcda09efe9d669dd6dfa294eaba03a.svg";